"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _reactMaterialUiFormValidator = require("react-material-ui-form-validator");
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _CustomCheckboxGroup = _interopRequireDefault(require("./CustomCheckboxGroup"));
var _excluded = ["errorMessages", "validators", "requiredError", "value"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CheckboxValidatorElement = exports["default"] = /*#__PURE__*/function (_ValidatorComponent) {
  function CheckboxValidatorElement() {
    (0, _classCallCheck2["default"])(this, CheckboxValidatorElement);
    return _callSuper(this, CheckboxValidatorElement, arguments);
  }
  (0, _inherits2["default"])(CheckboxValidatorElement, _ValidatorComponent);
  return (0, _createClass2["default"])(CheckboxValidatorElement, [{
    key: "renderValidatorComponent",
    value: function renderValidatorComponent() {
      var _this = this;
      var _this$props = this.props,
        errorMessages = _this$props.errorMessages,
        validators = _this$props.validators,
        requiredError = _this$props.requiredError,
        value = _this$props.value,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement("div", null, this.errorText(), /*#__PURE__*/_react["default"].createElement(_CustomCheckboxGroup["default"], (0, _extends2["default"])({}, rest, {
        ref: function ref(r) {
          _this.input = r;
        },
        value: value
      })));
    }
  }, {
    key: "errorText",
    value: function errorText() {
      var isValid = this.state.isValid;
      if (isValid) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
        error: true
      }, this.getErrorMessage());
    }
  }]);
}(_reactMaterialUiFormValidator.ValidatorComponent);